<template>
    <b-container fluid>
        <b-row>
            <b-col class="sidebar-col" sm="0" md="3" lg="3" xl="2" cols="6">
                <Sidebar />
            </b-col>
            <b-col class="right-col" sm="12" md="9" lg="9" xl="10" cols="6">
                <div>
                    <NavBar />
                </div>
                <router-view></router-view>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import NavBar from '@/components/Global/Navbar'
    import Sidebar from '@/components/Global/Sidebar'
    import '@/assets/scss/app_web.scss'
    export default {
        name: 'Home',
        components: {
            NavBar,
            Sidebar
        },
        methods: {}
    }
</script>
<style scoped>
</style>